import Proxy from './Proxy';

class MainMediaProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/settings/info/main-media', parameters);
  }

  saveList(item) {
    return this.submit('post', `/${this.endpoint}/save-list`, item );
  }  

}

export default MainMediaProxy;